import TextFade from "../../components/CustomTexts/TextFade";
//import CallToActionSection from "../../components/Others/CallToActionSection";
import heroImage from "../../assets/KEDA/image.png";
import sandDredgingImage from "../../assets/KEDA/keda1.jpg";
import TextEffect from "../../components/CustomTexts/TextEffect";
import bgIMG from "../../assets/tan2.jpg";
import trainingImg from "../../assets/KEDA/keda2.jpg";
import chysonImg from "../../assets/KEDA/keda11.jpg";
import farmImg from "../../assets/KEDA/keda4.jpg";
import consultancyImg from "../../assets/KEDA/keda5.jpg";
import consultancy2Img from "../../assets/KEDA/keda8.jpg";
import consultancy3Img from "../../assets/KEDA/keda9.jpg";
import consultancy4Img from "../../assets/KEDA/keda3.jpg";
import consultancy5Img from "../../assets/KEDA/keda7.jpg";
import consultancy6Img from "../../assets/KEDA/keda10.jpg";
import consultancy8Img from "../../assets/KEDA/save.jpg";
import consultancy7Img from "../../assets/KEDA/image.png";
import consultancy9Img from "../../assets/KEDA/saea.jpg";

//import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import { useState } from "react";

const ImageModal = ({ image, caption, onClose }: { image: string, caption: string, onClose: () => void }) => (
  <div className="fixed inset-0 bg-black bg-opacity-80 z-50 flex items-center justify-center p-4">
    <div className="bg-white rounded-lg shadow-lg max-w-3xl w-full overflow-hidden relative">
      <img src={image} alt={caption} className="w-full max-h-[80vh] object-contain" />
      <p className="text-center text-lg font-semibold text-dark py-4">{caption}</p>
      <button
        onClick={onClose}
        className="absolute top-2 right-2 text-white bg-black rounded-full p-2 hover:bg-gray-700"
      >
        ✕
      </button>
    </div>
  </div>
);

const KedaTraining = () => {
  const [modal, setModal] = useState<{ img: string; caption: string } | null>(null);
  const [activeTab, setActiveTab] = useState("participation");

  const trainingGallery = [
    { img: consultancy7Img, caption: "Hands-On Workshop" },
    { img: trainingImg, caption: "Personalized Mentorship" },
    { img: farmImg, caption: "Empowering Farmers" },
    { img: sandDredgingImage, caption: "Field Experience" },
    { img: consultancyImg, caption: "Consultancy Session" },
    { img: consultancy2Img, caption: "Knowledge Sharing" },
    { img: consultancy3Img, caption: "Community Engagement" },
    { img: consultancy4Img, caption: "Sustainable Practices" },
    { img: consultancy5Img, caption: "Innovative Solutions" },
    { img: chysonImg, caption: "Agricultural Training" },
    { img: consultancy6Img, caption: "Agricultural Training" }
    , { img: consultancy8Img, caption: "KEDA Commemoration" }
  ];

  const tabContent: Record<string, JSX.Element> = {
    participation: (
      <div className="flex flex-col md:flex-row items-center gap-10 group">
        <div className="md:w-1/2 space-y-4">
          <h3 className="text-[18px] md:text-[23px] font-semibold text-dark">
          Event Highlights (September 2021)
                    </h3>
          <p className="text-dark text-[15px] md:text-[18px] leading-relaxed">
The training gathered over 1000 women and youths at the Glasshouse inside the Kogi State Government House, Lokoja, to explore value-adding opportunities using Orange-Fleshed Sweet Potato (OFSP) </p>
 <p className="text-dark text-[15px] md:text-[18px] leading-relaxed">
Marking KEDA’s two-year anniversary, the 2-day program (September 7th – 8th, 2021) commenced with a media parley featuring key remarks from KEDA’s MD/CEO Hajiya Rekiya Onaivo Sanni  </p>

        </div>
        <div className="md:w-1/2">
          <img src={consultancy8Img} alt="Hands-On Workshops" className="rounded-2xl w-full h-full object-cover shadow-md" />
        </div>
      </div>
    ),
    rural: (
      <div className="flex flex-col md:flex-row items-center gap-10 group">
        <div className="md:w-1/2 space-y-4">
          <h3 className="text-[18px] md:text-[23px] font-semibold text-dark">
          Endorsements & Leadership
                </h3>
          <p className="text-dark text-[15px] md:text-[18px] leading-relaxed">
          The training was formally launched by the Secretary to the State Government, Mrs. Folashade Arike Ayoade, PhD, on behalf of His Excellency Governor Yahaya Bello
         </p>
          <p className="text-dark text-[15px] md:text-[18px] leading-relaxed">
          Dignitaries including the Commissioners for Commerce & Industry, Agriculture, Environment, and the Director of Women Affairs encouraged participants to recognize the wealth-creation potential of OFSP
        </p>
        </div>
        <div className="md:w-1/2">
          <img src={trainingImg} alt="Hands-On Workshops" className="rounded-2xl w-full h-full object-cover shadow-md" />
        </div>
      </div>
    ),
    health: (
      <div className="flex flex-col md:flex-row items-center gap-10 group">
        <div className="md:w-1/2 space-y-4">
          <h3 className="text-[18px] md:text-[23px] font-semibold text-dark">
          Learning & Practicals
                </h3>
          <p className="text-dark text-[15px] md:text-[18px] leading-relaxed">
          Day 1: Agronomic principles of OFSP were expertly delivered by Mr. Nduka Udeala, the OFSP consultant and lead facilitator.
         </p>

          <p className="text-dark text-[15px] md:text-[18px] leading-relaxed">
          Day 2: Participants visited a farm in Al-Azahar, Zango (Lokoja) for a hands-on demonstration of cultivation techniques, followed by a return to the Glasshouse for practical training in making puff-puff, chips, and smoothies from OFSP.
         </p>
        </div>
        <div className="md:w-1/2">
          <img src={consultancy4Img} alt="Hands-On Workshops" className="rounded-2xl w-full h-full object-cover shadow-md" />
        </div>
      </div>
    ),
    development: (
      <div className="flex flex-col md:flex-row-reverse items-center gap-10 group">
        <div className="md:w-1/2 space-y-4">
          <h3 className="text-[18px] md:text-[23px] font-semibold text-dark">
           Impact & Recognition
          </h3>
          <p className="text-dark text-[15px] md:text-[18px] leading-relaxed">
          Participants not only gained knowledge but also received certificates and planting materials—empowering them to start their own OFSP value-addition ventures
          </p>
        </div>
        <div className="md:w-1/2">
          <img src={consultancy9Img} alt="Mentorship" className="rounded-2xl w-full h-full object-cover shadow-md" />
        </div>
      </div>
    )
  };

  return (
    <div className="about-container">
      {/* Hero Section */}
      <div
        className="relative h-[60vh] flex items-center justify-center text-white bg-cover bg-center z-0"
        style={{ backgroundImage: `url(${heroImage})` }}
      >
        <div className="absolute inset-0 bg-black opacity-50 z-0" />
        <div className="z-10">
          <TextEffect text="KEDA Commemoration" className="hero-title" />
        </div>
      </div>

      {/* Tabbed Pane Section */}
      <div className="px-4 sm:px-[6%] mt-20 mb-24 gap-6">
                <div className="flex flex-wrap justify-center mb-8 space-x-4">
          <button
            onClick={() => setActiveTab("participation")}
            className={`px-4 py-2 rounded-full font-semibold text-sm md:text-base ${activeTab === "participation" ? "bg-green-600 text-white" : "bg-gray-200 text-gray-700 hover:bg-green-100"}`}
          >
       Empowerment & Event Highlights            </button>

          <button
            onClick={() => setActiveTab("rural")}
            className={`px-4 py-2 rounded-full font-semibold text-sm md:text-base ${activeTab === "rural" ? "bg-green-600 text-white" : "bg-gray-200 text-gray-700 hover:bg-green-100"}`}
          >
            Endorsements & Leadership
                 </button>
               
          <button
            onClick={() => setActiveTab("health")}
            className={`px-4 py-2 rounded-full font-semibold text-sm md:text-base ${activeTab === "health" ? "bg-green-600 text-white" : "bg-gray-200 text-gray-700 hover:bg-green-100"}`}
          >
        Learning & Practicals          </button>
          <button
            onClick={() => setActiveTab("development")}
            className={`px-4 py-2 rounded-full font-semibold text-sm md:text-base ${activeTab === "development" ? "bg-green-600 text-white" : "bg-gray-200 text-gray-700 hover:bg-green-100"}`}
          >
            Impact & Recognition
          </button>
        </div>

        <div className="transition-all duration-500">{tabContent[activeTab]}</div>
      </div>


      {/* Overview Section */}
      <div className="relative">
        <div
          className="relative bg-green-500 text-white px-4 sm:px-[5%] py-20 bg-cover bg-center z-0"
          style={{ backgroundImage: `url(${bgIMG})` }}
        >
          <div className="absolute inset-0 bg-green-650 opacity-80 z-0" />
          <div className="relative z-10 flex md:flex-row flex-col justify-between items-center gap-16">
            <div className="md:w-[40%] w-full flex justify-center">
              <img src={sandDredgingImage} alt="Empowering Farmers" className="w-[80%] max-w-[450px]" />
            </div>
            <div className="md:w-[60%] w-full space-y-4">
              <TextFade animation="fade-down">
                <h1 className="text-[30px] md:text-[40px] font-bold text-white mb-4 leading-tight">
                  <TextEffect text4="OVERVIEW OF KEDA COMMEMORATION" />
                </h1>
              </TextFade>
              <p className="text-white text-[17px] md:text-[20px] leading-relaxed">
In alignment with our mission to bolster livelihoods through agricultural empowerment, Simdozi International proudly supported the impactful KEDA OFSP value-addition training, spearheaded by the Kogi Enterprise Development Agency (KEDA).              </p>
              <p className="text-white text-[17px] md:text-[20px] leading-relaxed">
This initiative, held in Kogi State, Nigeria, from 24th to 26th July 2021, aimed to equip youth agripreneurs with essential skills in orange-fleshed sweet potato (OFSP) farming and value addition. Through hands-on training and mentorship, participants learned sustainable practices that enhance food security and nutrition while fostering economic growth in their communities.
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* Gallery Section */}
      <div className="px-4 sm:px-[5%] mt-24 mb-20">
        <TextFade animation="fade-up">
          <h1 className="text-center text-[24px] md:text-[30px] font-bold text-dark mb-8">
            <TextEffect part4="KEDA Commemoration Gallery" />
          </h1>
        </TextFade>

        <Swiper
          spaceBetween={20}
          slidesPerView={1}
          breakpoints={{
            640: { slidesPerView: 1.5 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 }
          }}
          navigation
          autoplay={{ delay: 3000 }}
          loop
          modules={[Navigation, Autoplay]}
        >
          {trainingGallery.map(({ img, caption }, index) => (
            <SwiperSlide key={index}>
              <div
                className="relative w-full h-[260px] sm:h-[300px] rounded-xl overflow-hidden group cursor-pointer"
                onClick={() => setModal({ img, caption })}
              >
                <img src={img} alt={caption} className="w-full h-full object-cover group-hover:scale-105 transition duration-500" />
                <div className="absolute inset-0 bg-black bg-opacity-30 flex items-center justify-center opacity-0 group-hover:opacity-100 transition duration-300">
                  <p className="text-white text-lg font-bold">{caption}</p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {modal && <ImageModal image={modal.img} caption={modal.caption} onClose={() => setModal(null)} />}
    </div>
  );
};

export default KedaTraining;
